import React from 'react';
import styled from 'styled-components';
import { Button, color as colors } from '@workboard/wobo-ui';
import { useTranslation } from "react-i18next";

function Presets({
  className,
  // eslint-disable-next-line
  onChange = () => {},
  // eslint-disable-next-line
  onReset = () => {},
  // eslint-disable-next-line
  onDismiss = () => {},
  // eslint-disable-next-line
  onSubmit = () => {},
  ...props
}) {
  const { t } = useTranslation();
  return (
    <div className={className} {...props}>
      <Button onClick={onReset} variant='secondary'>
        {t("Reset to current fiscal quarter")}
      </Button>
      <Button onClick={onSubmit} variant='primary'>
        {t("Apply")}
      </Button>
      <Button onClick={onDismiss} variant='ghost'>
        {t("Cancel")}
      </Button>
    </div>
  );
}

export default styled(Presets)`
  align-items: center;
  display: flow-root;
  justify-content: flex-end;
  padding: 0 16px 24px;

  ${Button} {
    margin: 8px 8px 0 0;
    float: right;

    &[data-selected='true'] {
      background: ${colors('--blue-200')};
    }
  }
  ${Button}:first-of-type {
    float: left;
  }
`;
